import { LinkedTokenSet } from "../../types/server.js";

export function formatTokenSetsAsMarkdown(tokenSets: LinkedTokenSet[]): string {
  if (tokenSets.length === 0) {
    return "No token sets available. You can link token sets in your styleguide's AI settings.";
  }
  return tokenSets.map((ts) => `- ${ts.name} (ID: ${ts.id})`).join("\n");
}
